import { render } from "./add_assesment.vue?vue&type=template&id=291604f9&lang=html"
import script from "./add_assesment.vue?vue&type=script&lang=js"
export * from "./add_assesment.vue?vue&type=script&lang=js"

import "./add_assesment.vue?vue&type=style&index=0&id=291604f9&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__